/**
 * Hero Slider — crossfade autoplay carousel
 * Pixel-perfect port of HeroSlider.tsx (React → Vanilla JS)
 *
 * Features:
 *  - Crossfade transition via opacity (class hero-slide--active)
 *  - Autoplay with configurable interval (data-autoplay-speed, seconds)
 *  - Dot navigation with pill-style active indicator
 *  - Pause on hover, resume on leave
 *  - Touch swipe support
 *  - Reinitialises on Shopify Theme Editor section:load / block events
 */

(function () {
  'use strict';

  function initSlider(slider) {
    var slides     = Array.from(slider.querySelectorAll('.hero-slide'));
    var dots       = Array.from(slider.querySelectorAll('.hero-slider__dot'));
    var speedSecs  = parseInt(slider.getAttribute('data-autoplay-speed') || '5', 10);
    var interval   = speedSecs * 1000;

    var current    = 0;
    var total      = slides.length;
    var timer      = null;
    var paused     = false;   /* transient: hover / focus / touch */
    var userPaused = false;   /* explicit: play-pause button / reduced-motion */
    var playBtn    = slider.querySelector('[data-hero-playpause]');
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (total <= 1) return;

    /* ---- activate a slide by index ---- */
    function goTo(index) {
      index = ((index % total) + total) % total;

      slides.forEach(function (s) { s.classList.remove('hero-slide--active'); });
      dots.forEach(function (d) { d.classList.remove('hero-slider__dot--active'); });

      slides[index].classList.add('hero-slide--active');
      if (dots[index]) dots[index].classList.add('hero-slider__dot--active');

      current = index;
    }

    function next() { goTo(current + 1); }

    /* ---- autoplay ---- */
    function startAutoplay() {
      stopAutoplay();
      if (!paused && !userPaused) {
        timer = setInterval(next, interval);
      }
    }

    /* ---- play / pause button ---- */
    function updatePlayBtn() {
      if (!playBtn) return;
      var pauseIcon = playBtn.querySelector('.hero-slider__icon--pause');
      var playIcon  = playBtn.querySelector('.hero-slider__icon--play');
      if (userPaused) {
        playBtn.setAttribute('aria-label', 'Riproduci lo slideshow');
        if (pauseIcon) pauseIcon.hidden = true;
        if (playIcon)  playIcon.hidden = false;
      } else {
        playBtn.setAttribute('aria-label', 'Metti in pausa lo slideshow');
        if (pauseIcon) pauseIcon.hidden = false;
        if (playIcon)  playIcon.hidden = true;
      }
    }

    if (playBtn) {
      playBtn.addEventListener('click', function () {
        userPaused = !userPaused;
        updatePlayBtn();
        if (userPaused) { stopAutoplay(); } else { startAutoplay(); }
      });
    }

    /* ---- pause on keyboard focus within the slider ---- */
    slider.addEventListener('focusin', function () {
      paused = true;
      stopAutoplay();
    });

    slider.addEventListener('focusout', function (e) {
      if (!slider.contains(e.relatedTarget)) {
        paused = false;
        startAutoplay();
      }
    });

    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    /* ---- dot clicks ---- */
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var idx = parseInt(this.getAttribute('data-dot-index'), 10);
        goTo(idx);
        /* reset autoplay timer after manual navigation */
        stopAutoplay();
        startAutoplay();
      });
    });

    /* ---- pause on hover ---- */
    slider.addEventListener('mouseenter', function () {
      paused = true;
      stopAutoplay();
    });

    slider.addEventListener('mouseleave', function () {
      paused = false;
      startAutoplay();
    });

    /* ---- touch swipe ---- */
    var touchStartX = 0;

    slider.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      paused = true;
      stopAutoplay();
    }, { passive: true });

    slider.addEventListener('touchend', function (e) {
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) {
        goTo(diff > 0 ? current + 1 : current - 1);
      }
      paused = false;
      startAutoplay();
    }, { passive: true });

    /* ---- boot ---- */
    goTo(0);
    if (reduceMotion) {
      userPaused = true;   /* respect the user's reduced-motion preference */
    }
    updatePlayBtn();
    startAutoplay();
  }

  /* ---- initialise all sliders on the page ---- */
  function initAll() {
    document.querySelectorAll('[data-hero-slider]').forEach(function (el) {
      /* avoid double-init */
      if (el.dataset.heroSliderInit) return;
      el.dataset.heroSliderInit = '1';
      initSlider(el);
    });
  }

  document.addEventListener('DOMContentLoaded', initAll);

  /* Shopify Theme Editor live-preview support */
  document.addEventListener('shopify:section:load',  initAll);
  document.addEventListener('shopify:block:select',  initAll);
})();
